
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $b156a4bb5957e824$exports = {};
/**
 * name: body-scroll-lock-upgrade
 * version: v1.1.0
 * author: Rick.li
 */ (function(global, factory) {
    factory($b156a4bb5957e824$exports);
})($b156a4bb5957e824$exports, function(exports2) {
    "use strict";
    let hasPassiveEvents = false;
    if (typeof window !== "undefined") {
        const passiveTestOptions = {
            get passive () {
                hasPassiveEvents = true;
                return void 0;
            }
        };
        window.addEventListener("testPassive", null, passiveTestOptions);
        window.removeEventListener("testPassive", null, passiveTestOptions);
    }
    const isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
    let locks = [];
    let locksIndex = /* @__PURE__ */ new Map();
    let documentListenerAdded = false;
    let initialClientY = -1;
    let previousBodyOverflowSetting;
    let htmlStyle;
    let bodyStyle;
    let previousBodyPaddingRight;
    const allowTouchMove = (el)=>locks.some((lock)=>{
            if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
            return false;
        });
    const preventDefault = (rawEvent)=>{
        const e = rawEvent || window.event;
        if (allowTouchMove(e.target)) return true;
        if (e.touches.length > 1) return true;
        if (e.preventDefault) e.preventDefault();
        return false;
    };
    const setOverflowHidden = (options)=>{
        if (previousBodyPaddingRight === void 0) {
            const reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
            const scrollBarGap = window.innerWidth - document.documentElement.getBoundingClientRect().width;
            if (reserveScrollBarGap && scrollBarGap > 0) {
                const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
                previousBodyPaddingRight = document.body.style.paddingRight;
                document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarGap}px`;
            }
        }
        if (previousBodyOverflowSetting === void 0) {
            previousBodyOverflowSetting = document.body.style.overflow;
            document.body.style.overflow = "hidden";
        }
    };
    const restoreOverflowSetting = ()=>{
        if (previousBodyPaddingRight !== void 0) {
            document.body.style.paddingRight = previousBodyPaddingRight;
            previousBodyPaddingRight = void 0;
        }
        if (previousBodyOverflowSetting !== void 0) {
            document.body.style.overflow = previousBodyOverflowSetting;
            previousBodyOverflowSetting = void 0;
        }
    };
    const setPositionFixed = ()=>window.requestAnimationFrame(()=>{
            const $html = document.documentElement;
            const $body = document.body;
            if (bodyStyle === void 0) {
                htmlStyle = {
                    ...$html.style
                };
                bodyStyle = {
                    ...$body.style
                };
                const { scrollY: scrollY, scrollX: scrollX, innerHeight: innerHeight } = window;
                $html.style.height = "100%";
                $html.style.overflow = "hidden";
                $body.style.position = "fixed";
                $body.style.top = `${-scrollY}px`;
                $body.style.left = `${-scrollX}px`;
                $body.style.width = "100%";
                $body.style.height = "auto";
                $body.style.overflow = "hidden";
                setTimeout(()=>window.requestAnimationFrame(()=>{
                        const bottomBarHeight = innerHeight - window.innerHeight;
                        if (bottomBarHeight && scrollY >= innerHeight) $body.style.top = -(scrollY + bottomBarHeight) + "px";
                    }), 300);
            }
        });
    const restorePositionSetting = ()=>{
        if (bodyStyle !== void 0) {
            const y = -parseInt(document.body.style.top, 10);
            const x = -parseInt(document.body.style.left, 10);
            const $html = document.documentElement;
            const $body = document.body;
            $html.style.height = (htmlStyle == null ? void 0 : htmlStyle.height) || "";
            $html.style.overflow = (htmlStyle == null ? void 0 : htmlStyle.overflow) || "";
            $body.style.position = bodyStyle.position || "";
            $body.style.top = bodyStyle.top || "";
            $body.style.left = bodyStyle.left || "";
            $body.style.width = bodyStyle.width || "";
            $body.style.height = bodyStyle.height || "";
            $body.style.overflow = bodyStyle.overflow || "";
            window.scrollTo(x, y);
            bodyStyle = void 0;
        }
    };
    const isTargetElementTotallyScrolled = (targetElement)=>targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
    const handleScroll = (event, targetElement)=>{
        const clientY = event.targetTouches[0].clientY - initialClientY;
        if (allowTouchMove(event.target)) return false;
        if (targetElement && targetElement.scrollTop === 0 && clientY > 0) return preventDefault(event);
        if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) return preventDefault(event);
        event.stopPropagation();
        return true;
    };
    const disableBodyScroll = (targetElement, options)=>{
        if (!targetElement) {
            console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
            return;
        }
        locksIndex.set(targetElement, (locksIndex == null ? void 0 : locksIndex.get(targetElement)) ? (locksIndex == null ? void 0 : locksIndex.get(targetElement)) + 1 : 1);
        if (locks.some((lock2)=>lock2.targetElement === targetElement)) return;
        const lock = {
            targetElement: targetElement,
            options: options || {}
        };
        locks = [
            ...locks,
            lock
        ];
        if (isIosDevice) setPositionFixed();
        else setOverflowHidden(options);
        if (isIosDevice) {
            targetElement.ontouchstart = (event)=>{
                if (event.targetTouches.length === 1) initialClientY = event.targetTouches[0].clientY;
            };
            targetElement.ontouchmove = (event)=>{
                if (event.targetTouches.length === 1) handleScroll(event, targetElement);
            };
            if (!documentListenerAdded) {
                document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? {
                    passive: false
                } : void 0);
                documentListenerAdded = true;
            }
        }
    };
    const clearAllBodyScrollLocks = ()=>{
        if (isIosDevice) {
            locks.forEach((lock)=>{
                lock.targetElement.ontouchstart = null;
                lock.targetElement.ontouchmove = null;
            });
            if (documentListenerAdded) {
                document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? {
                    passive: false
                } : void 0);
                documentListenerAdded = false;
            }
            initialClientY = -1;
        }
        if (isIosDevice) restorePositionSetting();
        else restoreOverflowSetting();
        locks = [];
        locksIndex.clear();
    };
    const enableBodyScroll = (targetElement)=>{
        if (!targetElement) {
            console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
            return;
        }
        locksIndex.set(targetElement, (locksIndex == null ? void 0 : locksIndex.get(targetElement)) ? (locksIndex == null ? void 0 : locksIndex.get(targetElement)) - 1 : 0);
        if ((locksIndex == null ? void 0 : locksIndex.get(targetElement)) === 0) {
            locks = locks.filter((lock)=>lock.targetElement !== targetElement);
            locksIndex == null || locksIndex.delete(targetElement);
        }
        if (isIosDevice) {
            targetElement.ontouchstart = null;
            targetElement.ontouchmove = null;
            if (documentListenerAdded && locks.length === 0) {
                document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? {
                    passive: false
                } : void 0);
                documentListenerAdded = false;
            }
        }
        if (locks.length === 0) {
            if (isIosDevice) restorePositionSetting();
            else restoreOverflowSetting();
        }
    };
    exports2.clearAllBodyScrollLocks = clearAllBodyScrollLocks;
    exports2.disableBodyScroll = disableBodyScroll;
    exports2.enableBodyScroll = enableBodyScroll;
    Object.defineProperty(exports2, Symbol.toStringTag, {
        value: "Module"
    });
}); //# sourceMappingURL=index.umd.js.map


const $b9eba5a31eae3293$var$btnOpen = document.querySelector("#btnOpen");
const $b9eba5a31eae3293$var$btnClose = document.querySelector("#btnClose");
const $b9eba5a31eae3293$var$media = window.matchMedia("(max-width: 48em)");
const $b9eba5a31eae3293$var$mainNavMenu = document.querySelector(".mainnav__menu");
const $b9eba5a31eae3293$var$main = document.querySelector("main");
const $b9eba5a31eae3293$var$body = document.querySelector("body");
function $b9eba5a31eae3293$var$openMobileMenu() {
    $b9eba5a31eae3293$var$btnOpen.setAttribute("aria-expanded", "true");
    $b9eba5a31eae3293$var$mainNavMenu.removeAttribute("inert");
    $b9eba5a31eae3293$var$mainNavMenu.removeAttribute("style");
    $b9eba5a31eae3293$var$main.setAttribute("inert", "");
    (0, (/*@__PURE__*/$parcel$interopDefault($b156a4bb5957e824$exports))).disableBodyScroll($b9eba5a31eae3293$var$body);
    $b9eba5a31eae3293$var$btnClose.focus();
}
function $b9eba5a31eae3293$var$closeMobileMenu() {
    $b9eba5a31eae3293$var$btnOpen.setAttribute("aria-expanded", "false");
    $b9eba5a31eae3293$var$mainNavMenu.setAttribute("inert", "");
    $b9eba5a31eae3293$var$main.removeAttribute("inert");
    $b9eba5a31eae3293$var$btnOpen.focus();
    (0, (/*@__PURE__*/$parcel$interopDefault($b156a4bb5957e824$exports))).enableBodyScroll($b9eba5a31eae3293$var$body);
    setTimeout(()=>{
        $b9eba5a31eae3293$var$mainNavMenu.style.transition = "none";
    }, 500);
}
function $b9eba5a31eae3293$var$setupTopNav(e) {
    e.matches ? ($b9eba5a31eae3293$var$mainNavMenu.setAttribute("inert", ""), $b9eba5a31eae3293$var$mainNavMenu.style.transition = "none") : ($b9eba5a31eae3293$var$mainNavMenu.removeAttribute("inert"), $b9eba5a31eae3293$var$mainNavMenu.style.transition = "", $b9eba5a31eae3293$var$mainNavMenu.style.transitionProperty = "transform");
}
$b9eba5a31eae3293$var$setupTopNav($b9eba5a31eae3293$var$media);
$b9eba5a31eae3293$var$btnOpen.addEventListener("click", $b9eba5a31eae3293$var$openMobileMenu);
$b9eba5a31eae3293$var$btnClose.addEventListener("click", $b9eba5a31eae3293$var$closeMobileMenu);
$b9eba5a31eae3293$var$media.addEventListener("change", function(e) {
    $b9eba5a31eae3293$var$setupTopNav(e);
});


const $a3fb9f0cbd10e37d$export$691c5185eac2cefa = document.getElementById("goalieTable"); //Get div to render data
const $a3fb9f0cbd10e37d$export$50421dc344b88c35 = document.getElementById("defensemenTable"); //Get div to render data
const $a3fb9f0cbd10e37d$export$dd8188c03a31bcec = document.getElementById("forwardTable"); //Get div to render data
let $a3fb9f0cbd10e37d$export$aa4f8ad266a6ac9e = document.getElementById("teamGrid");
const $a3fb9f0cbd10e37d$export$bd11a5444bc59e81 = document.getElementById("statsLeaderGoals");
const $a3fb9f0cbd10e37d$export$fae5bfcc942062be = document.getElementById("statsLeaderPoints");
const $a3fb9f0cbd10e37d$export$9a23e22af3350f8 = document.getElementById("statsLeaderAssists");
const $a3fb9f0cbd10e37d$export$620183cd202b2dfa = document.getElementById("statsLeaderPlusMinus");
const $a3fb9f0cbd10e37d$export$9720956328033a7e = document.getElementById("teamStatsbar");
const $a3fb9f0cbd10e37d$export$b1d45de535dfff9b = document.getElementById("teamLogo");
const $a3fb9f0cbd10e37d$export$e880e043f966b761 = document.getElementById("teamName");
const $a3fb9f0cbd10e37d$export$e54c90470ecfa0b9 = document.getElementById("teamsPageMain");
const $a3fb9f0cbd10e37d$export$7a842d38f5fccf7a = document.getElementById("playersPageMain");
const $a3fb9f0cbd10e37d$export$5eb4e5b5d3cd6c63 = document.getElementById("wikiData");
const $a3fb9f0cbd10e37d$export$b38406ba51ba90c1 = document.getElementById("playerHeaderInfo");
const $a3fb9f0cbd10e37d$export$6f53e00fe20086d0 = document.getElementById("playerActionImg");
const $a3fb9f0cbd10e37d$export$e12baa86bd58df6c = document.getElementById("playerTeamRoster");
const $a3fb9f0cbd10e37d$export$efaac8a9fe7728b9 = document.getElementById("playerProfileInfo");
const $a3fb9f0cbd10e37d$export$5a45d39693a9d4b8 = document.getElementById("playerStatsbar");
const $a3fb9f0cbd10e37d$export$4d4c62c1f960d38b = document.getElementById("gamesTable");
const $a3fb9f0cbd10e37d$export$176bb6869ae1ac4f = document.getElementById("gamesTableHead");
// Extract the query string parameters from the URL
const $a3fb9f0cbd10e37d$export$ded69dcd8ce7e468 = window.location.search;
const $a3fb9f0cbd10e37d$var$urlParams = new URLSearchParams($a3fb9f0cbd10e37d$export$ded69dcd8ce7e468);
const $a3fb9f0cbd10e37d$export$3bc5123856734909 = window.location.pathname;
const $a3fb9f0cbd10e37d$export$f54e0459d8018b61 = $a3fb9f0cbd10e37d$var$urlParams.get("teamid"); // Get the team ID from the query string parameters
const $a3fb9f0cbd10e37d$export$aed86d65fa6d1974 = $a3fb9f0cbd10e37d$var$urlParams.get("playerid"); // Get the player ID from the query string parameters
// const baseURL = "https://frek1802-dt211g-projekt.netlify.app"; // Base URL for API requests used for local production
const $a3fb9f0cbd10e37d$export$e0588e7b8006558e = ""; // Clear base url on live site


// nhlStatsAPI.js

const $7e20b57b4be39966$var$playerIDs = [
    8477493,
    8477935,
    8476393,
    8479981,
    8479367,
    8479066,
    8478904,
    8482113,
    8480185,
    8477933,
    8478542,
    8478831,
    8479314,
    8477409,
    8477932,
    8475171,
    8478055,
    8475179,
    8479372,
    8478859,
    8477986,
    8475683,
    8476932,
    8475968,
    8477380,
    8480078,
    8482157,
    8481726,
    8476624,
    8481554,
    8475184,
    8482109,
    8478550,
    8482460,
    8476389,
    8476918,
    8471218,
    8476459,
    8479323,
    8476979,
    8481708,
    8479324,
    8480817,
    8482073,
    8476885,
    8471734,
    8478048,
    8480003,
    8479638,
    8475745,
    8478498,
    8479365,
    8479987,
    8478046,
    8480880,
    8473419,
    8483397,
    8477956,
    8483505,
    8474037,
    8478401,
    8478443,
    8475762,
    8476891,
    8476854,
    8482511,
    8479325,
    8474031,
    8478450,
    8480280,
    8476999,
    8482496,
    8476927,
    8478444,
    8476858,
    8478856,
    8481535,
    8478057,
    8478043,
    8477496,
    8481624,
    8476468,
    8480012,
    8480459,
    8478465,
    8474013,
    8478017,
    8479425,
    8480800,
    8478454,
    8474574,
    8477359,
    8477369,
    8477507,
    8477967,
    8479193,
    8473994,
    8474149,
    8480848,
    8475168,
    8476889,
    8478449,
    8482740,
    8478975,
    8470794,
    8480027,
    8475794,
    8475225,
    8482702,
    8479351,
    8475825,
    8477810,
    8481581,
    8480036,
    8476902,
    8480878,
    8470600,
    8475690,
    8479979,
    8475809,
    8478891,
    8480289,
    8478398,
    8477940,
    8481019,
    8480113,
    8480845,
    8476392,
    8477497,
    8476480,
    8475799,
    8482149,
    8476460,
    8480014,
    8476331,
    8475455,
    8477504,
    8480145,
    8480049,
    8477220,
    8479378,
    8476316,
    8476945,
    8471699,
    8479525,
    8477494,
    8475793,
    8481641,
    8477476,
    8477492,
    8481186,
    8470610,
    8478420,
    8475780,
    8477425,
    8481524,
    8479398,
    8471677,
    8478452,
    8480069,
    8476312,
    8478038,
    8481020,
    8480382,
    8477479,
    8477503,
    8479393,
    8480995,
    8475714,
    8480144,
    8482720,
    8478483,
    8479318,
    8482259,
    8477939,
    8471817,
    8475166,
    8481122,
    8474673,
    8470966,
    8475906,
    8478021,
    8480043,
    8480950,
    8476931,
    8474162,
    8476853,
    8479982,
    8474889,
    8478492,
    8479361,
    8478427,
    8478047,
    8480835,
    8475855,
    8482093,
    8480829,
    8477962,
    8476921,
    8480039,
    8476474,
    8473533,
    8480830,
    8476882,
    8470613,
    8478970,
    8477950,
    8475200,
    8477488,
    8476869,
    8476958,
    8475883,
    8481611,
    8477484,
    8477293,
    8477015,
    8477934,
    8477998,
    8474040,
    8482077,
    8475786,
    8477406,
    8475169,
    8478402,
    8480802,
    8476454,
    8470621,
    8478585,
    8480803,
    8476879,
    8479576,
    8475218,
    8476967,
    8477498,
    8475717,
    8479973,
    8478020,
    8477964,
    8482153,
    8477478,
    8481032,
    8480844,
    8481604,
    8478403,
    8475278,
    8479353,
    8476448,
    8478434,
    8476539,
    8481462,
    8478462,
    8476905,
    8475913,
    8481600,
    8479980,
    8477018,
    8474166,
    8475188,
    8482624,
    8474565,
    8477447,
    8480727,
    8478499,
    8480313,
    8477456,
    8477429,
    8479337,
    8477952,
    8478432,
    8474141,
    8480011,
    8477946,
    8474102,
    8479992,
    8482078,
    8478466,
    8480813,
    8475279,
    8476906,
    8475718,
    8476874,
    8473507,
    8481542,
    8478013,
    8478024,
    8479312,
    8473503,
    8482146,
    8476887,
    8479996,
    8478495,
    8476873,
    8477446,
    8478438,
    8474679,
    8475158,
    8480748,
    8476925,
    8482062,
    8478508,
    8475197,
    8478851,
    8479371,
    8474600,
    8478468,
    8474151,
    8474568,
    8480947,
    8477424,
    8482070,
    8478519,
    8479591,
    8476822,
    8479542,
    8479661,
    8476453,
    8477353,
    8477426,
    8478010,
    8477839,
    8474564,
    8475766,
    8478416,
    8481719,
    8475177,
    8477938,
    8475167,
    8482929,
    8480246,
    8478178,
    8479410,
    8477992,
    8476883,
    8474715,
    8481553,
    8480220,
    8476461,
    8475235,
    8480797,
    8482159,
    8480028,
    8477903,
    8478439,
    8476872,
    8480245,
    8480068,
    8480015,
    8481521,
    8482142,
    8475176,
    8477499,
    8477948,
    8476372,
    8471686,
    8480336,
    8481546,
    8481178,
    8481035,
    8478433,
    8479994,
    8478042,
    8482124,
    8476479,
    8479400,
    8477942,
    8479336,
    8481560,
    8477960,
    8471685,
    8482155,
    8473453,
    8481481,
    8479675,
    8481532,
    8479998,
    8482730,
    8474563,
    8477971,
    8478882,
    8479421,
    8478911,
    8481606,
    8477831,
    8479496,
    8475660,
    8478445,
    8475231,
    8473504,
    8478115,
    8477392,
    8481601,
    8477500,
    8475314,
    8481237,
    8474709,
    8475754,
    8476419,
    8475151,
    8480789,
    8480222,
    8481541,
    8474145,
    8480865,
    8476429,
    8476917,
    8477506,
    8476422,
    8481014,
    8478009,
    8473575,
    8477979,
    8473563,
    8475343,
    8483920,
    8482148,
    8479359,
    8477511,
    8481580,
    8477947,
    8483491,
    8471698,
    8471214,
    8474157,
    8481656,
    8475958,
    8478440,
    8476880,
    8480823,
    8478451,
    8474590,
    8476441,
    8480796,
    8475324,
    8480873,
    8477845,
    8475311,
    8479292,
    8474150,
    8476399,
    8482652,
    8478421,
    8476456,
    8478211,
    8475172,
    8483808,
    8478233,
    8481592,
    8481028,
    8479291,
    8481068,
    8482074,
    8478397,
    8478502,
    8478396,
    8478430,
    8477851,
    8481167,
    8477346,
    8474593,
    8478435,
    8481543,
    8478104,
    8482737,
    8477402,
    8475763,
    8477953,
    8479385,
    8482089,
    8476438,
    8475170,
    8476897,
    8480023,
    8480281,
    8477573,
    8475753,
    8476792,
    8475181,
    8476892,
    8481059,
    8474618,
    8481006,
    8476412,
    8480981,
    8479414,
    8479407,
    8475287,
    8480002,
    8482125,
    8481559,
    8477508,
    8477073,
    8478414,
    8482110,
    8477931,
    8476292,
    8476919,
    8475726,
    8480860,
    8480084,
    8476462,
    8482684,
    8478507,
    8476525,
    8483495,
    8478399,
    8474090,
    8482076,
    8481033,
    8477970,
    8477930,
    8482665,
    8477416,
    8477444,
    8474586,
    8476826,
    8481789,
    8477955,
    8475768,
    8479293,
    8475193,
    8480009,
    8477505,
    8479977,
    8478840,
    8475208,
    8478407,
    8482858,
    8476457,
    8476467,
    8474602,
    8478916,
    8475831,
    8478569,
    8480205,
    8470604,
    8471675,
    8474189,
    8477404,
    8478424,
    8471215,
    8476442,
    8482055,
    8479547,
    8479344,
    8481703,
    8476483,
    8475810,
    8475191,
    8477435,
    8480058,
    8474578,
    8471724,
    8481206,
    8477969,
    8477244,
    8477465,
    8477968,
    8484145,
    8481528,
    8476878,
    8478413,
    8481522,
    8479999,
    8473449,
    8478109,
    8482175,
    8482097,
    8480762,
    8475784,
    8479420,
    8477949,
    8480196,
    8477365,
    8480839,
    8473446,
    8481564,
    8480035,
    8482671,
    8480807,
    8477480,
    8480045,
    8481557,
    8480980,
    8479520,
    8478493,
    8475220,
    8477919,
    8477451,
    8475149,
    8478864,
    8479968,
    8481422,
    8474034,
    8482079,
    8479972,
    8475692,
    8474567,
    8476463,
    8480990,
    8482122,
    8471274,
    8477541,
    8475750,
    8478136,
    8474716,
    8470594,
    8479406,
    8476981,
    8476469,
    8481540,
    8481523,
    8477989,
    8478133,
    8475848,
    8481093,
    8481618,
    8476871,
    8479543,
    8482749,
    8483515,
    8480018,
    8478400,
    8481058,
    8482087,
    8480887,
    8480192,
    8476875,
    8475233,
    8481593,
    8482964,
    8474596,
    8478470,
    8480051,
    8480208,
    8473512,
    8482092,
    8478472,
    8480355,
    8480448,
    8477330,
    8479772,
    8480064,
    8481596,
    8482116,
    8475765,
    8480801,
    8480879,
    8480073,
    8478469,
    8479345,
    8481679,
    8474612,
    8482105,
    8482245,
    8476341,
    8476914,
    8482447,
    8481544,
    8475760,
    8476329,
    8479619,
    8483431,
    8478474,
    8482699,
    8480849,
    8479343,
    8477021,
    8481711,
    8480855,
    8477070,
    8477951,
    8475722,
    8477384,
    8478408,
    8476856,
    8480434,
    8480891,
    8482655,
    8479442,
    8479976,
    8478971,
    8478872,
    8482475,
    8479941,
    8484166,
    8476346,
    8476432,
    8482660,
    8476374,
    8480893,
    8479423,
    8479671,
    8478458,
    8482705,
    8480074,
    8481716,
    8479402,
    8480871,
    8475790,
    8479369,
    8478500,
    8476923,
    8478460,
    8478007,
    8480193,
    8484153,
    8475842,
    8480870,
    8474641,
    8477527,
    8479368,
    8473986,
    8481517,
    8480806,
    8476934,
    8482745,
    8475164,
    8476458,
    8478873,
    8478366,
    8481533,
    8475764,
    8475462,
    8481605,
    8480184,
    8483490,
    8480001,
    8482803,
    8480843,
    8476434,
    8477473,
    8482222,
    8477846,
    8474053,
    8477407,
    8482667,
    8475798,
    8476881,
    8474884,
    8479316,
    8478099,
    8479379,
    8481477,
    8480821,
    8480188,
    8480884,
    8476988,
    8477335,
    8480834,
    8479983,
    8481537,
    8480172,
    8481567,
    8471709,
    8478406,
    8480992,
    8478039,
    8479315,
    8476960,
    8478463,
    8484144,
    8476278,
    8477450,
    8477987,
    8480025,
    8473422,
    8480252,
    8475791,
    8481147,
    8474870,
    8479383,
    8480798,
    8478224,
    8479390,
    8477482,
    8481806,
    8477495,
    8483466,
    8477034,
    8476473,
    8482192,
    8475797,
    8481568,
    8479458,
    8475852,
    8482821
];
function $7e20b57b4be39966$export$bceb287b2dee3825() {
    const randomIndex = Math.floor(Math.random() * $7e20b57b4be39966$var$playerIDs.length);
    // Getting a random number from playerIDs
    const randomNumber = $7e20b57b4be39966$var$playerIDs[randomIndex];
    return randomNumber;
}


//Fetch NHL teams
async function $f022bd453edfc391$export$bbbfd6b4973ce033(baseURL) {
    try {
        let teamsData = sessionStorage.getItem("NHLTeams");
        if (teamsData) {
            teamsData = JSON.parse(teamsData);
            return teamsData;
        } else {
            const response = await fetch(`${baseURL}/.netlify/functions/apidata?url=https://api-web.nhle.com/v1/standings/now`);
            teamsData = await response.json();
            // console.log("Fetched teams from API:");
            // console.log(teamsData);
            sessionStorage.setItem("NHLTeams", JSON.stringify(teamsData));
            return teamsData;
        }
    } catch (error) {
        console.error("Error fetching NHL teams data: ", error);
        return error;
    }
}
//Fetch Statsleaders
async function $f022bd453edfc391$export$52e5e69085c41f96() {
    try {
        let statsLeaderData = sessionStorage.getItem("statsLeaders");
        if (statsLeaderData) {
            statsLeaderData = JSON.parse(statsLeaderData);
            // console.log("Fetched statsleaders from session storage:");
            // console.log(statsLeaderData);
            return statsLeaderData;
        } else {
            const response = await fetch(`${(0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e)}/.netlify/functions/apidata?url=https://api-web.nhle.com/v1/skater-stats-leaders/current`);
            statsLeaderData = await response.json();
            // console.log("Fetched tatsleaders from API:");
            sessionStorage.setItem("statsLeaders", JSON.stringify(statsLeaderData));
            return statsLeaderData;
        }
    } catch (error) {
        console.error("Error: ", error);
        return error;
    }
}
//Fetch NHLRosters
async function $f022bd453edfc391$export$64a8ab7ca472edab(baseURL, teamAbb) {
    try {
        let rosterData = sessionStorage.getItem(`tr-${teamAbb}`); // Get rosterData from sessionStorage if it exists.
        if (rosterData) {
            rosterData = JSON.parse(rosterData);
            // console.log("Fetched roster from session storage:");
            // console.log(rosterData);
            return rosterData; // Return rosterData if fetched from sessionStorage.
        } else {
            const response = await fetch(`${baseURL}/.netlify/functions/apidata?url=https://api-web.nhle.com/v1/roster/${teamAbb}/current`);
            rosterData = await response.json();
            // console.log("Fetched roster from API:");
            // console.log(rosterData);
            sessionStorage.setItem(`tr-${teamAbb}`, JSON.stringify(rosterData));
            return rosterData; // Return rosterData fetched from API.
        }
    } catch (error) {
        console.error("Error:", error);
        return null; // Return null if there's an error fetching the rosterData.
    }
}
//Fetch players
async function $f022bd453edfc391$export$5a9cf9e2f142c72c(baseURL, playerID) {
    try {
        let playerData = sessionStorage.getItem(`p-${playerID}`);
        if (playerData) playerData = JSON.parse(playerData);
        else {
            const response = await fetch(`${baseURL}/.netlify/functions/apidata?url=https://api-web.nhle.com/v1/player/${playerID}/landing`);
            playerData = await response.json();
            // console.log("Fetched player from api:");
            // console.log(playerData);
            sessionStorage.setItem(`p-${playerID}`, JSON.stringify(playerData));
        }
        let playerName;
        //If Swedish or Skandinavian name exist use that, else use deafult
        if (playerData.lastName.sv) {
            if (playerData.firstName.sv) playerName = `${playerData.firstName.sv} ${playerData.lastName.sv}`;
            else playerName = `${playerData.firstName.default} ${playerData.lastName.sv}`;
        } else if (playerData.lastName.sk) {
            if (playerData.firstName.sk) playerName = `${playerData.firstName.sk} ${playerData.lastName.sk}`;
            else playerName = `${playerData.firstName.default} ${playerData.lastName.sk}`;
        } else playerName = `${playerData.firstName.default} ${playerData.lastName.default}`;
        $f022bd453edfc391$export$9c07e1094470d2e3(baseURL, playerName);
        return playerData;
    } catch (error) {
        console.error("Error: ", error);
    }
}
//Fetch and Render Wiki Content
async function $f022bd453edfc391$export$9c07e1094470d2e3(baseURL, searchQuery) {
    const apiUrl = "https://sv.wikipedia.org/w/api.php";
    const params = new URLSearchParams({
        action: "query",
        format: "json",
        prop: "extracts",
        exintro: true,
        explaintext: true,
        titles: searchQuery
    });
    const apiUrlEncoded = encodeURIComponent(`${apiUrl}?${params}`);
    const fetchUrl = `${baseURL}/.netlify/functions/apidata?url=${apiUrlEncoded}`;
    try {
        let pageContent = sessionStorage.getItem(`wiki-${searchQuery}`);
        if (pageContent) pageContent = JSON.parse(pageContent);
        else {
            // console.log("Page content is not available in sessions storage");
            const response = await fetch(fetchUrl);
            const data = await response.json();
            const pages = data.query.pages;
            const pageId = Object.keys(pages)[0]; // Get the page ID
            pageContent = pages[pageId].extract; // Get the page content
            // console.log("Fetched wikidata from API:");
            // console.log(pageContent); // Handle the response data here
            if (!pageContent) pageContent = "Kan inte h\xe4mta information fr\xe5n Wikipedia.";
            sessionStorage.setItem(`wiki-${searchQuery}`, JSON.stringify(pageContent));
        }
        //If Wiki data element exists, render the pageContent to element
        if (0, $a3fb9f0cbd10e37d$export$5eb4e5b5d3cd6c63) (0, $a3fb9f0cbd10e37d$export$5eb4e5b5d3cd6c63).innerHTML += `${pageContent}`;
        return pageContent;
    } catch (error) {
        console.error("Error:", error);
    }
}
//Pre fetch team - gets called on hover of team in teamsgrid
async function $f022bd453edfc391$export$c1a033cbc4ce8396(teamID, teamsData) {
    await $f022bd453edfc391$export$64a8ab7ca472edab((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), teamID);
    //Find current team
    const currentTeam = teamsData.standings.find((data)=>data.teamAbbrev.default == teamID);
    // console.log(currentTeam);
    // console.log("Filtered team:", currentTeam.teamName.default);
    //Render teamname and logo
    const teamName = currentTeam.teamName.default;
    //Clean team name from é and fetch Wikipedia content
    const cleanTeamName = teamName.replace(/é/g, "e");
    $f022bd453edfc391$export$9c07e1094470d2e3((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), cleanTeamName);
}
//Fetch a random player
async function $f022bd453edfc391$export$f47c48ce5a8c2820() {
    try {
        const randomPlayerID = (0, $7e20b57b4be39966$export$bceb287b2dee3825)(); //Get a random playerid from playerids. js
        // console.log("randomplayerID:", randomPlayerID);
        const playerData = await $f022bd453edfc391$export$5a9cf9e2f142c72c((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), randomPlayerID);
        // console.log("Random player data:", playerData);
        return playerData;
    } catch (error) {
        console.error("Ingen spelare hittad:", error);
    }
}



//Eventlisteners
if (0, $a3fb9f0cbd10e37d$export$e12baa86bd58df6c) (0, $a3fb9f0cbd10e37d$export$e12baa86bd58df6c).addEventListener("change", ()=>{
    // console.log(playerTeamRosterEl.value);
    window.location.href = `/players.html?playerid=${(0, $a3fb9f0cbd10e37d$export$e12baa86bd58df6c).value}`;
});
// Render Teams Grid
async function $a76cd3211bcef81a$export$378ebd396cacafac(el) {
    try {
        const teamsData = await (0, $f022bd453edfc391$export$bbbfd6b4973ce033)((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e));
        // console.log(teamsData);
        const sortedTeamsData = teamsData.standings.toSorted((a, b)=>a.teamName.default.localeCompare(b.teamName.default)); //Sort teams alphabeticals
        sortedTeamsData.forEach((team)=>{
            el.innerHTML += `
        <!-- Start of ${team.teamAbbrev.default} -->
        <a href="/teams.html?teamid=${team.teamAbbrev.default}" class="team__box" id="${team.teamAbbrev.default}">
            <img class="team__logo--medium" src="${team.teamLogo}" alt="">
            <p class="small">${team.teamName.default}</p>
        </a>
        <!-- End of ${team.teamAbbrev.default} -->
        `;
        });
        const teamElements = document.querySelectorAll(".team__box");
        // Add event listener to each team element
        teamElements.forEach((teamElement)=>{
            teamElement.addEventListener("mouseenter", ()=>{
                const teamAbbrev = teamElement.id;
                // console.log(`Team ${teamAbbrev} hovered`);
                (0, $f022bd453edfc391$export$c1a033cbc4ce8396)(teamAbbrev, teamsData);
            }, {
                once: true
            });
        });
    } catch (error) {
        console.error("Error:", error);
    }
}
// Render NHLTeam
async function $a76cd3211bcef81a$export$ac27b05cf87083b5(teamID) {
    try {
        // console.log("TeamID:", teamID);
        const teamsData = await (0, $f022bd453edfc391$export$bbbfd6b4973ce033)((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e));
        //Find current team
        const currentTeam = teamsData.standings.find((data)=>data.teamAbbrev.default == teamID);
        const teamRank = teamsData.standings.findIndex((data)=>data.teamAbbrev.default === teamID) + 1;
        // console.log(currentTeam);
        // console.log("Filtered team:", currentTeam.teamName.default);
        //Render teamname and logo
        const teamName = currentTeam.teamName.default;
        (0, $a3fb9f0cbd10e37d$export$e880e043f966b761).innerText = `${teamName}`;
        (0, $a3fb9f0cbd10e37d$export$b1d45de535dfff9b).innerHTML += `<img src="${currentTeam.teamLogo}" alt="${teamName} logo">`;
        //Change document title    
        document.title += ` | ${teamName}`;
        //Clean team name from é and fetch Wikipedia content
        const cleanTeamName = teamName.replace(/é/g, "e");
        (0, $f022bd453edfc391$export$9c07e1094470d2e3)((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), cleanTeamName);
        //Convert seasonId to string and format it
        const seasonId = currentTeam.seasonId.toString();
        const formattedSeasonId = `${seasonId.slice(0, 4)}-${seasonId.slice(4)}`;
        // console.log(formattedSeasonId);
        //Render Statsbar content
        (0, $a3fb9f0cbd10e37d$export$9720956328033a7e).innerHTML += `
        <h2>${formattedSeasonId}</h2>
        
        <div class="statsbar__stats">
            <!-- Rank -->
            <div class="statsbar__stats--box">
            <p class="smallest">Rank</p>
            <p class="statsbar__stats--box--stat">${teamRank}</p>
            </div>
            <!-- Games played -->
            <div class="statsbar__stats--box">
            <p class="smallest">GP</p>
            <p class="statsbar__stats--box--stat">${currentTeam.gamesPlayed}</p>
            </div>
            <!-- Wins -->
            <div class="statsbar__stats--box">
            <p class="smallest">W</p>
            <p class="statsbar__stats--box--stat">${currentTeam.wins}</p>
            </div>
            <!-- Losses -->
            <div class="statsbar__stats--box">
            <p class="smallest">L</p>
            <p class="statsbar__stats--box--stat">${currentTeam.losses}</p>
            </div>
            <!-- OT Losses -->
            <div class="statsbar__stats--box">
            <p class="smallest">OTL</p>
            <p class="statsbar__stats--box--stat">${currentTeam.otLosses}</p>
            </div>
            <!-- OT Losses -->
            <div class="statsbar__stats--box">
            <p class="smallest">P</p>
            <p class="statsbar__stats--box--stat">${currentTeam.points}</p>
            </div>
        </div>
        `;
        //Call function to render team roster
        $a76cd3211bcef81a$export$c041c6fb6123da4f((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), teamID);
    } catch (error) {
        console.error("Error:", error);
    }
}
//Render team roster
async function $a76cd3211bcef81a$export$c041c6fb6123da4f(baseURL, teamID) {
    try {
        const rosterData = await (0, $f022bd453edfc391$export$64a8ab7ca472edab)(baseURL, teamID);
        // console.log("Rosterdata:", rosterData.goalies);
        if (rosterData) {
            // Render each category of players
            rosterData.goalies.forEach((goalie)=>{
                (0, $a3fb9f0cbd10e37d$export$691c5185eac2cefa).innerHTML += `
            <tr>
            <td><a href="/players?playerid=${goalie.id}"><img class="statsleader__card--list--img" src="${goalie.headshot}" alt=""> ${goalie.firstName.default} ${goalie.lastName.default}</a></td>
            <td><a href="/players?playerid=${goalie.id}"> ${goalie.sweaterNumber}</a></td>
            <td><a href="/players?playerid=${goalie.id}"> ${goalie.positionCode}</a></td>
            <td><a href="/players?playerid=${goalie.id}"> ${goalie.shootsCatches}</a></td>
            <td><a href="/players?playerid=${goalie.id}"> ${goalie.heightInCentimeters}</a></td>
            <td><a href="/players?playerid=${goalie.id}"> ${goalie.weightInKilograms}</a></td>
            </tr>
            `;
                sessionStorage.setItem(`pre-p-${goalie.id}`, JSON.stringify(goalie));
            });
            rosterData.defensemen.forEach((defender)=>{
                (0, $a3fb9f0cbd10e37d$export$50421dc344b88c35).innerHTML += `
            <tr>
            <td><a href="/players?playerid=${defender.id}"><img class="statsleader__card--list--img" src="${defender.headshot}" alt=""> ${defender.firstName.default} ${defender.lastName.default}</a></td>
            <td><a href="/players?playerid=${defender.id}"> ${defender.sweaterNumber}</a></td>
            <td><a href="/players?playerid=${defender.id}"> ${defender.positionCode}</a></td>
            <td><a href="/players?playerid=${defender.id}"> ${defender.shootsCatches}</a></td>
            <td><a href="/players?playerid=${defender.id}"> ${defender.heightInCentimeters}</a></td>
            <td><a href="/players?playerid=${defender.id}"> ${defender.weightInKilograms}</a></td>
            </tr>
            `;
                sessionStorage.setItem(`pre-p-${defender.id}`, JSON.stringify(defender));
            });
            rosterData.forwards.forEach((forward)=>{
                (0, $a3fb9f0cbd10e37d$export$dd8188c03a31bcec).innerHTML += `
            <tr>
            <td><a href="/players?playerid=${forward.id}"><img class="statsleader__card--list--img" src="${forward.headshot}" alt=""> ${forward.firstName.default} ${forward.lastName.default}</a></td>
            <td><a href="/players?playerid=${forward.id}"> ${forward.sweaterNumber}</a></td>
            <td><a href="/players?playerid=${forward.id}"> ${forward.positionCode}</a></td>
            <td><a href="/players?playerid=${forward.id}"> ${forward.shootsCatches}</a></td>
            <td><a href="/players?playerid=${forward.id}"> ${forward.heightInCentimeters}</a></td>
            <td><a href="/players?playerid=${forward.id}"> ${forward.weightInKilograms}</a></td>
            </tr>
            `;
                sessionStorage.setItem(`pre-p-${forward.id}`, JSON.stringify(forward));
            });
        }
    } catch (error) {
        console.error("Error:", error);
    }
}
// Render Statscards
async function $a76cd3211bcef81a$export$753e6644c8b46e78() {
    try {
        const data = await (0, $f022bd453edfc391$export$52e5e69085c41f96)();
        const statElements = [
            [
                "points",
                (0, $a3fb9f0cbd10e37d$export$fae5bfcc942062be)
            ],
            [
                "goals",
                (0, $a3fb9f0cbd10e37d$export$bd11a5444bc59e81)
            ],
            [
                "assists",
                (0, $a3fb9f0cbd10e37d$export$9a23e22af3350f8)
            ],
            [
                "plusMinus",
                (0, $a3fb9f0cbd10e37d$export$620183cd202b2dfa)
            ]
        ];
        if (!data) // console.log("no data");
        return;
        for (const [statType, statElement] of statElements)if (statElement) {
            statElement.innerHTML = "";
            let i = 1;
            data[statType].forEach((player)=>{
                const playerName = `${player.firstName.default} ${player.lastName.default}`;
                const statValue = statType === "plusMinus" ? `+${player.value}` : player.value;
                if (i === 1) {
                    statElement.innerHTML = `
                        <!-- Start of top -->
                        <a href="/players.html?playerid=${player.id}" class="statsleader__card--top statsleader__card--top">
                            <div class="statsleader__card--top--text">
                                <div>
                                    <p class="small">${player.firstName.default}</p>
                                    <p class="statsleader__card--top--name">${player.lastName.default}</p>
                                </div>
                                <p class="statsleader__card--top--stat">${statValue}</p>
                            </div>
                            <div>
                                <img src="${player.headshot}" alt="Portr\xe4tt av ${playerName}">
                            </div>
                        </a>
                        <!-- End of top -->
                        <div class="statsleader__card--list">
                    `;
                    i++;
                } else {
                    statElement.innerHTML += `
                        <!-- Item ${i} -->
                        <a href="/players.html?playerid=${player.id}">
                            <div class="statsleader__card--list--item">
                                <p class="statsleader__card--list--rank smallest">${i}</p>
                                <img class="statsleader__card--list--img" src="${player.headshot}" alt="Portr\xe4tt av ${playerName}">
                                <p class="statsleader__card--list--name small" >${playerName}</p>
                                <p class="statsleader__card--list--stat">${statValue}</p>
                            </div>
                        </a>
                    `;
                    i++;
                }
            });
            statElement.innerHTML += `</div>`;
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}
//Render Player
async function $a76cd3211bcef81a$export$de63367cfa83728c(playerID) {
    try {
        let playerData;
        let prePlayerData;
        if (!playerID) playerData = await (0, $f022bd453edfc391$export$f47c48ce5a8c2820)();
        else {
            //Check if some player data already exists in sessionstorage.
            prePlayerData = sessionStorage.getItem(`pre-p-${playerID}`);
            if (prePlayerData) {
                prePlayerData = JSON.parse(prePlayerData);
                $a76cd3211bcef81a$var$preRenderPlayer(prePlayerData);
            }
            playerData = await (0, $f022bd453edfc391$export$5a9cf9e2f142c72c)((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), playerID);
        // console.log("Fetch player succesful now render: ", playerData);
        }
        $a76cd3211bcef81a$var$renderPlayerHeader(playerData);
        $a76cd3211bcef81a$var$renderPlayerInfo(playerData);
        $a76cd3211bcef81a$var$renderPlayerStats(playerData);
        $a76cd3211bcef81a$var$renderPlayerGameLog(playerData);
        if (!playerData) {
            console.log("no data");
            return;
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}
async function $a76cd3211bcef81a$var$renderPlayerHeader(playerData) {
    let playerName = `${playerData.firstName.default} ${playerData.lastName.default}`;
    (0, $a3fb9f0cbd10e37d$export$b38406ba51ba90c1).innerHTML = `
        <a href="teams?teamid=${playerData.currentTeamAbbrev}" ><img src="${playerData.teamLogo}" class="team__logo--medium" alt="Logo f\xf6r ${playerData.currentTeamAbbrev}"></a>
        <h1 class="player__heading"><span>${playerData.position}  |  #${playerData.sweaterNumber}</span> <span>${playerName}</span></h1>
    `;
    (0, $a3fb9f0cbd10e37d$export$6f53e00fe20086d0).innerHTML = `
        <img src="${playerData.heroImage}"  alt="Actionbild av ${playerData.fullTeamName.default} spelaren ${playerName}" class="player__action--image">
    `;
    const currentPlayerID = playerData.playerId; //Get current players ID
    const rosterData = await (0, $f022bd453edfc391$export$64a8ab7ca472edab)((0, $a3fb9f0cbd10e37d$export$e0588e7b8006558e), playerData.currentTeamAbbrev); //Fetch players teamroster
    //Loop through the object
    Object.entries(rosterData).forEach(([position, players])=>{
        //Loop through players
        players.forEach((player)=>{
            //If player id is not = current player
            if (player.id != currentPlayerID) {
                (0, $a3fb9f0cbd10e37d$export$e12baa86bd58df6c).innerHTML += `
                <option value="${player.id}">${player.firstName.default} ${player.lastName.default}</option>
            `;
                sessionStorage.setItem(`pre-p-${player.id}`, JSON.stringify(player));
            } else (0, $a3fb9f0cbd10e37d$export$e12baa86bd58df6c).innerHTML += `
                <option value="${player.id}" selected>${player.firstName.default} ${player.lastName.default}</option>
            `;
        });
    });
}
//Render player info on player profile
function $a76cd3211bcef81a$var$renderPlayerInfo(playerData) {
    let playerName = `${playerData.firstName.default} ${playerData.lastName.default}`;
    (0, $a3fb9f0cbd10e37d$export$efaac8a9fe7728b9).innerHTML = `
    <img src="${playerData.headshot}" class="player__banner--img"  alt="Profilbild av ${playerName}">
    <div>
        <p class="smallest">L\xe4ngd: ${playerData.heightInCentimeters} cm</p>
        <p class="smallest">Vikt: ${playerData.weightInKilograms} kg</p>
        <p class="smallest">F\xf6dd: ${playerData.birthDate}</p>
        <p class="smallest">Land: ${playerData.birthCountry}</p>
        <p class="smallest">F\xf6delseort: ${playerData.birthCity.sv ? playerData.birthCity.sv : playerData.birthCity.default}</p>
        <p class="smallest">Fattning: ${playerData.shootsCatches}</p>
        <p class="smallest">Draft: ${playerData.draftDetails ? `#${playerData.draftDetails.overallPick}, ${playerData.draftDetails.year} till ${playerData.draftDetails.teamAbbrev}` : "Inte draftad"}</p>
    </div>
`;
}
//Render player statsbars
function $a76cd3211bcef81a$var$renderPlayerStats(playerData) {
    const seasonId = playerData.featuredStats.season.toString(); //Make seasonid a string
    const formattedSeasonId = `${seasonId.slice(0, 4)}-${seasonId.slice(4)}`; //Format the string
    const seasonData = playerData.featuredStats.regularSeason.subSeason; //Set current seasons data to variable
    const careerData = playerData.featuredStats.regularSeason.career; //Set career data to varialbe
    let seasonStatsData; //Declare variable to store seasondata
    let careerStatsData; //Declare variable to store careerdata
    //Create statsobject based on player postion
    if (playerData.position != "G") {
        //Season stats
        seasonStatsData = {
            GP: seasonData.gamesPlayed,
            G: seasonData.goals,
            A: seasonData.assists,
            P: seasonData.points,
            "+/-": seasonData.plusMinus
        };
        //Career stats
        careerStatsData = {
            GP: careerData.gamesPlayed,
            G: careerData.goals,
            A: careerData.assists,
            P: careerData.points,
            "+/-": careerData.plusMinus
        };
    } else {
        //Season stats
        seasonStatsData = {
            GP: seasonData.gamesPlayed,
            W: seasonData.wins,
            SO: seasonData.shutouts,
            GAA: seasonData.goalsAgainstAvg.toFixed(2),
            "SV%": (seasonData.savePctg * 100).toFixed(2)
        };
        //Career stats
        careerStatsData = {
            GP: careerData.gamesPlayed,
            W: careerData.wins,
            SO: careerData.shutouts,
            GAA: careerData.goalsAgainstAvg.toFixed(2),
            "SV%": (careerData.savePctg * 100).toFixed(2)
        };
    }
    //Render the statsbar
    (0, $a3fb9f0cbd10e37d$export$5a45d39693a9d4b8).innerHTML = `
        <div class="statsbar">
            <h2>${formattedSeasonId}</h2>
            <div class="statsbar__stats">
            ${//Loop through object
    Object.entries(seasonStatsData).reduce((html, [statIdentifier, statValue])=>{
        return html + `
                    <div class="statsbar__stats--box">
                        <p class="smallest">${statIdentifier}</p>
                        <p class="statsbar__stats--box--stat">${statValue}</p>
                    </div>
                `;
    }, "")}
            </div>
        </div>

        <div class="statsbar">
            <h2>Karri\xe4r</h2>
            <div class="statsbar__stats">
            ${Object.entries(careerStatsData).reduce((html, [statIdentifier, statValue])=>{
        return html + `
                    <div class="statsbar__stats--box">
                        <p class="smallest">${statIdentifier}</p>
                        <p class="statsbar__stats--box--stat">${statValue}</p>
                    </div>
                `;
    }, "")}
            </div>
        </div>
    `;
}
//Render player gamelog
function $a76cd3211bcef81a$var$renderPlayerGameLog(playerData) {
    let tableHeaders; //Declare variable to store table headers data
    //Create table headers based on position
    if (playerData.position != "G") //Skaters
    tableHeaders = [
        "Datum",
        "VS",
        "G",
        "A",
        "P",
        "+/-",
        "PIM",
        "TOI"
    ];
    else //Goailes
    tableHeaders = [
        "Datum",
        "VS",
        "W/L",
        "SA",
        "GA",
        "SV%"
    ];
    //Create table headers
    // Create a new table row 
    let tableRow = document.createElement("tr");
    // Loop through table headers and create table headers
    tableHeaders.forEach((stat)=>{
        let tableHeaderCell = document.createElement("th");
        tableHeaderCell.textContent = stat;
        tableRow.appendChild(tableHeaderCell); // Append the table header cell to the table row
    });
    // Append the completed the finished row to table header
    (0, $a3fb9f0cbd10e37d$export$176bb6869ae1ac4f).appendChild(tableRow);
    //Render table games / statlog
    if (playerData.position != "G") playerData.last5Games.forEach((game)=>{
        (0, $a3fb9f0cbd10e37d$export$4d4c62c1f960d38b).innerHTML += `
            <tr>
            <td>${game.gameDate}</td>
            <td>${game.opponentAbbrev}</td>
            <td>${game.goals}</td>
            <td>${game.assists}</td>
            <td>${game.points}</td>
            <td>${game.plusMinus}</td>
            <td>${game.pim}</td>
            <td>${game.toi}</td>
            </tr>
            `;
    });
    else playerData.last5Games.forEach((game)=>{
        // console.log(game);
        (0, $a3fb9f0cbd10e37d$export$4d4c62c1f960d38b).innerHTML += `
            <tr>
            <td>${game.gameDate}</td>
            <td>${game.opponentAbbrev}</td>
            <td>${game.decision}</td>
            <td>${game.shotsAgainst}</td>
            <td>${game.goalsAgainst}</td>
            <td>${(game.savePctg * 100).toFixed(2)} %</td>
            </tr>
            `;
    });
}
//Pre render some of the playerdata before making the fetch.
function $a76cd3211bcef81a$var$preRenderPlayer(playerData) {
    // console.log("prerenderPlayer:", playerData);
    let playerName = `${playerData.firstName.default} ${playerData.lastName.default}`;
    (0, $a3fb9f0cbd10e37d$export$b38406ba51ba90c1).innerHTML = `
    <h1 class="player__heading"><span>#${playerData.sweaterNumber}</span> <span>${playerName}</span></h1>
    `;
    (0, $a3fb9f0cbd10e37d$export$efaac8a9fe7728b9).innerHTML = `
        <img src="${playerData.headshot}" class="player__banner--img"  alt="Profilbild av ${playerName}">
        <div>
            <p class="smallest">L\xe4ngd: ${playerData.heightInCentimeters} cm</p>
            <p class="smallest">Vikt: ${playerData.weightInKilograms} kg</p>
            <p class="smallest">F\xf6dd: ${playerData.birthDate}</p>
            <p class="smallest">Land: ${playerData.birthCountry}</p>
            <p class="smallest">F\xf6delseort: ${playerData.birthCity.default}</p>
            <p class="smallest">Fattning: ${playerData.shootsCatches}</p>
        </div>
    `;
}


if (0, $a3fb9f0cbd10e37d$export$bd11a5444bc59e81) (0, $a76cd3211bcef81a$export$753e6644c8b46e78)();
if (0, $a3fb9f0cbd10e37d$export$f54e0459d8018b61) (0, $a76cd3211bcef81a$export$ac27b05cf87083b5)((0, $a3fb9f0cbd10e37d$export$f54e0459d8018b61).toUpperCase());
else if (!(0, $a3fb9f0cbd10e37d$export$f54e0459d8018b61) && (0, $a3fb9f0cbd10e37d$export$e54c90470ecfa0b9)) {
    // console.log('RenderTeamsGrid Function');
    (0, $a3fb9f0cbd10e37d$export$e54c90470ecfa0b9).innerHTML = `
      <div class="section__padding--light-bg">
        <section class="container--l" aria-label="NHL-lag">
          <h2 class="line-heading--small">Lag</h2>
          <div class="grid__teams section__padding" id="teamGrid"></div>
        </section>
      </div>
    `;
    let teamGrid = document.getElementById("teamGrid");
    // console.log(teamGrid);
    (0, $a76cd3211bcef81a$export$378ebd396cacafac)(teamGrid);
}
if ((0, $a3fb9f0cbd10e37d$export$aa4f8ad266a6ac9e) && (0, $a3fb9f0cbd10e37d$export$3bc5123856734909) == "/") (0, $a76cd3211bcef81a$export$378ebd396cacafac)((0, $a3fb9f0cbd10e37d$export$aa4f8ad266a6ac9e));
if (!(0, $a3fb9f0cbd10e37d$export$aed86d65fa6d1974) && (0, $a3fb9f0cbd10e37d$export$7a842d38f5fccf7a)) // console.log("Fetch Random player no id:");
(0, $a76cd3211bcef81a$export$de63367cfa83728c)();
else if ((0, $a3fb9f0cbd10e37d$export$aed86d65fa6d1974) == "rand") // console.log("Fetch Random player id: rand");
(0, $a76cd3211bcef81a$export$de63367cfa83728c)();
else if (0, $a3fb9f0cbd10e37d$export$aed86d65fa6d1974) // console.log("Fetch player player id:", playerID);
(0, $a76cd3211bcef81a$export$de63367cfa83728c)((0, $a3fb9f0cbd10e37d$export$aed86d65fa6d1974));


//# sourceMappingURL=index.78f789f0.js.map
